import React, {useState} from 'react';

import axios from 'axios';
import {mainurl} from '../../../Mainurl';

import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../../style/color';
import { Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, Badge } from 'reactstrap';

import AddPlanning from './AddPlanning';
import { FaEye, FaPlus, FaCalendarAlt, FaSeedling, FaUsers, FaChartLine } from 'react-icons/fa';
import { MdDashboard, MdDateRange } from 'react-icons/md';

const Planning = () => {

    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState('');
    
    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState('');

    let get_planning_list = () => {
            
            let postData = [{"org_id": sessionStorage.getItem('org_id')}]
            axios({
                method: 'post',
                url: mainurl + 'Activity/planning_view',
                data: postData,
                headers: { 'Content-Type': 'application/JSON', }
            })
                .then(function (response) {
                    // Store raw data for statistics calculation
                    setRawData(response.data);
                    
                    let list = response.data.map((row, index) => {
                        return{
                            sl: index + 1,
                            date: <div className="d-flex align-items-center gap-2">
                                <FaCalendarAlt className="text-primary" size={14} />
                                <span className="fw-medium">{row.planning_date.split(" ")[0].split('-').reverse().join('-')}</span>
                            </div>,
                            crop: <div className="d-flex align-items-center gap-2">
                                <FaSeedling className="text-success" size={14} />
                                <span className="fw-medium">{row.crop_variety_name}</span>
                            </div>,
                            target_area: <Badge color="info" className="fw-normal px-3 py-2">
                                {row.area +" "+ row.land_uom_desc}
                            </Badge>,
                            total_farmer: <div className="d-flex align-items-center gap-2">
                                <FaUsers className="text-warning" size={14} />
                                <span className="fw-bold text-success">{row.total_farmer}</span>
                            </div>,
                            view: <Button 
                                color="primary" 
                                size="sm" 
                                className="btn-icon rounded-circle p-2" 
                                onClick={()=>farmer_list_handler(row.farmer_detail)}
                                style={{ transition: 'all 0.2s ease' }}
                            >
                                <FaEye size={14} />
                            </Button>
                        } 
                        
                    });
    
                    setTableData(list);
                })
                .catch(error => {
                    setLoading(false);
                    //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                    //notify();
                });
    }

    const farmer_list_handler = (dtl) => {
        
        const list = dtl.map((row, index) => {
            return{
                sl: index + 1,
                farmer_code: <Badge color="secondary" className="fw-normal">{row.farmer_code}</Badge>,
                farmer_name: <div className="fw-medium">{row.f_name} <span className="text-muted">({row.f_name_ne})</span></div>
            }    
        })
        
        setModalData(list);
        setViewModal(true);
    }

    // Calculate statistics from raw data
    const [rawData, setRawData] = useState([]);
    
    const totalPlans = Array.isArray(tableData) ? tableData.length : 0;
    const totalFarmers = Array.isArray(rawData) ? rawData.reduce((sum, plan) => {
        return sum + (parseInt(plan.total_farmer) || 0);
    }, 0) : 0;
    const totalArea = Array.isArray(rawData) ? rawData.reduce((sum, plan) => {
        return sum + (parseFloat(plan.area) || 0);
    }, 0) : 0;

    return(
        <>
            {/* Quick Stats Cards */}
            <Row className="g-4 mb-4">
                <Col lg={4} md={6}>
                    <Card className="stat-card h-100 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="stat-title text-muted mb-2 fw-medium">Total Plans</h6>
                                    <h3 className="stat-value mb-1 fw-bold text-primary">
                                        {totalPlans}
                                    </h3>
                                    <small className="text-success">Active planning</small>
                                </div>
                                <div className="stat-icon-wrapper">
                                    <div 
                                        className="stat-icon d-flex align-items-center justify-content-center text-primary"
                                        style={{ 
                                            backgroundColor: '#07653815', 
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <MdDashboard size={28} />
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                
                <Col lg={4} md={6}>
                    <Card className="stat-card h-100 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="stat-title text-muted mb-2 fw-medium">Total Farmers</h6>
                                    <h3 className="stat-value mb-1 fw-bold text-success">
                                        {totalFarmers}
                                    </h3>
                                    <small className="text-success">Enrolled</small>
                                </div>
                                <div className="stat-icon-wrapper">
                                    <div 
                                        className="stat-icon d-flex align-items-center justify-content-center text-success"
                                        style={{ 
                                            backgroundColor: '#2E8B5715', 
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <FaUsers size={28} />
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                
                <Col lg={4} md={6}>
                    <Card className="stat-card h-100 shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardBody className="p-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="flex-grow-1">
                                    <h6 className="stat-title text-muted mb-2 fw-medium">Target Area</h6>
                                    <h3 className="stat-value mb-1 fw-bold text-warning">
                                        {totalArea.toFixed(1)}
                                    </h3>
                                    <small className="text-success">
                                        {Array.isArray(rawData) && rawData.length > 0 ? rawData[0].land_uom_desc || 'Units' : 'Units'}
                                    </small>
                                </div>
                                <div className="stat-icon-wrapper">
                                    <div 
                                        className="stat-icon d-flex align-items-center justify-content-center text-warning"
                                        style={{ 
                                            backgroundColor: '#DAA52015', 
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '12px'
                                        }}
                                    >
                                        <FaChartLine size={28} />
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {mode === 1 && 
                <>
                    {/* Action Buttons */}
                    <Card className='mb-3 shadow-sm border-0' style={{ borderRadius: '10px' }}>
                        <CardBody className="p-3">
                            <Row>
                                <Col xs={12}>
                                    <div className="d-flex flex-wrap gap-2">
                                        <Button 
                                            className='d-flex align-items-center gap-2 px-4 py-2' 
                                            color='primary' 
                                            style={{ borderRadius: '8px', fontWeight: '500' }}
                                            onClick={get_planning_list}
                                        > 
                                            <FaChartLine size={14} />
                                            Get Plan List 
                                        </Button>
                                        <Button 
                                            className='d-flex align-items-center gap-2 px-4 py-2' 
                                            color='success' 
                                            style={{ borderRadius: '8px', fontWeight: '500' }}
                                            onClick={() => {setMode(2); get_planning_list();}}
                                        > 
                                            <FaPlus size={14} />
                                            Add New Plan 
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {/* Planning List Table */}
                    <Card className="shadow-sm border-0" style={{ borderRadius: '10px' }}>
                        <CardHeader className='d-flex justify-content-between align-items-center py-3' style={{
                            backgroundColor: '#f8f9fa',
                            borderBottom: '2px solid #e9ecef',
                            borderRadius: '10px 10px 0 0'
                        }}>
                            <div className="d-flex align-items-center gap-2">
                                <MdDateRange className="text-primary" size={20} />
                                <span className="fw-bold">Planning List</span>
                            </div>
                            <Badge color="primary" className="px-3 py-2">
                                {totalPlans} Plans
                            </Badge>
                        </CardHeader>
                        <CardBody className="p-0">
                            <DataTable
                                customStyles={{
                                    ...custTableStyles,
                                    headRow: {
                                        style: {
                                            backgroundColor: '#f8f9fa',
                                            borderBottom: '2px solid #dee2e6',
                                            fontWeight: '600'
                                        }
                                    },
                                    rows: {
                                        style: {
                                            '&:hover': {
                                                backgroundColor: '#f8f9fa',
                                                transform: 'scale(1.001)',
                                                transition: 'all 0.2s ease'
                                            }
                                        }
                                    }
                                }}
                                columns={[
                                    {
                                        name: 'SL. No.',
                                        selector: row => row.sl,
                                        sortable: false,
                                        width: '80px',
                                        center: true
                                    },
                                    {
                                        name: 'Planning Date',
                                        selector: row => row.date,
                                        sortable: false,
                                    },
                                    {
                                        name: 'Crop',
                                        selector: row => row.crop,
                                        sortable: false,
                                    },
                                    {
                                        name: 'Target Area',
                                        selector: row => row.target_area,
                                        sortable: false,
                                        center: true
                                    },
                                    {
                                        name: 'Total Farmer',
                                        selector: row => row.total_farmer,
                                        sortable: false,
                                        width: '150px',
                                    },
                                    {
                                        name: 'View Details',
                                        selector: row => row.view,
                                        sortable: false,
                                        center: true
                                    },
                                ]}
                                data={tableData}
                                highlightOnHover
                                progressPending={loading}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                noDataComponent={
                                    <div className="text-center py-5">
                                        <FaSeedling size={48} className="text-muted mb-3" />
                                        <h5 className="text-muted">No planning data found</h5>
                                        <p className="text-muted">Click "Get Plan List" to load data or "Add New Plan" to create one.</p>
                                    </div>
                                }
                            />
                        </CardBody>
                    </Card>
                </>
            }
            
            {mode === 2 && 
                <AddPlanning back={()=> setMode(1)} />
            }

            {/* Enhanced Modal for Farmer Details */}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
                className="custom-modal"
            >
                <ModalHeader 
                    toggle={() => setViewModal(!viewModal)}
                    className="border-bottom-0 pb-1"
                    style={{ backgroundColor: '#f8f9fa' }}
                >
                    <div className="d-flex align-items-center gap-2">
                        <FaUsers className="text-primary" size={20} />
                        <span className="fw-bold">Farmer Details</span>
                    </div>
                </ModalHeader>
                <ModalBody className="p-0">
                    <DataTable
                        customStyles={{
                            ...custTableStyles,
                            headRow: {
                                style: {
                                    backgroundColor: '#f8f9fa',
                                    fontWeight: '600'
                                }
                            },
                            rows: {
                                style: {
                                    '&:hover': {
                                        backgroundColor: '#f8f9fa'
                                    }
                                }
                            }
                        }}
                        columns={[
                            {
                                name: '#',
                                selector: row => row.sl,
                                sortable: true,
                                width: '80px',
                                center: true
                            },
                            {
                                name: 'Farmer Code',
                                selector: row => row.farmer_code,
                                sortable: false,
                                center: true
                            },
                            {
                                name: 'Farmer Name',
                                selector: row => row.farmer_name,
                                sortable: false,
                                width: "60%"
                            }
                        ]}
                        data={modalData}
                        highlightOnHover
                        pagination
                        paginationPerPage={8}
                        progressPending={loading}
                        noDataComponent={
                            <div className="text-center py-4">
                                <FaUsers size={32} className="text-muted mb-2" />
                                <p className="text-muted mb-0">No farmer data available</p>
                            </div>
                        }
                    />
                </ModalBody>
            </Modal>

            <style jsx>{`
                .stat-card {
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }

                .stat-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
                }

                .stat-title {
                    font-size: 0.85rem;
                    letter-spacing: 0.5px;
                }

                .stat-value {
                    font-size: 2rem;
                    line-height: 1.2;
                }

                .btn-icon {
                    transition: all 0.2s ease;
                }

                .btn-icon:hover {
                    transform: scale(1.1);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }

                .custom-modal .modal-content {
                    border-radius: 10px;
                    border: none;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                }

                .stat-card {
                    animation: fadeInUp 0.5s ease-out;
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 768px) {
                    .stat-value {
                        font-size: 1.5rem;
                    }
                    
                    .stat-icon {
                        width: 50px !important;
                        height: 50px !important;
                    }

                    .d-flex.gap-2 {
                        flex-direction: column;
                        gap: 0.5rem !important;
                    }

                    .btn {
                        font-size: 0.875rem;
                        padding: 8px 16px !important;
                    }
                }

                /* DataTable Enhancements */
                .rdt_Table {
                    border-radius: 0 0 10px 10px;
                }

                .rdt_TableHead {
                    background-color: #f8f9fa !important;
                }

                .rdt_TableRow:hover {
                    background-color: #f8f9fa !important;
                    cursor: pointer;
                }

                /* Badge Enhancements */
                .badge {
                    font-size: 0.75rem;
                    padding: 0.375rem 0.75rem;
                    border-radius: 6px;
                    font-weight: 500;
                }

                /* Button Enhancements */
                .btn {
                    transition: all 0.2s ease;
                    border: none;
                }

                .btn:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }

                /* Card Shadow Enhancement */
                .shadow-sm {
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
                }

                /* Loading Animation */
                .loading-skeleton {
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    animation: loading 1.5s infinite;
                    border-radius: 4px;
                }

                @keyframes loading {
                    0% {
                        background-position: 200% 0;
                    }
                    100% {
                        background-position: -200% 0;
                    }
                }

                /* Enhanced no-data component */
                .no-data-component {
                    padding: 3rem 2rem;
                    text-align: center;
                    color: #6c757d;
                }

                /* Responsive Table */
                @media (max-width: 768px) {
                    .rdt_Table {
                        font-size: 0.875rem;
                    }
                    
                    .stat-card .d-flex {
                        flex-direction: column;
                        align-items: flex-start !important;
                        gap: 1rem;
                    }
                    
                    .stat-icon-wrapper {
                        align-self: flex-end;
                    }
                }

                /* Smooth transitions for all interactive elements */
                * {
                    transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
                }

                /* Focus states for accessibility */

                /* Enhanced hover effects for better UX */
                .card:hover {
                    transition: all 0.3s ease;
                }

                .table-responsive {
                    border-radius: 0 0 10px 10px;
                }
            `}</style>
        </>
    )
}

export default Planning;